//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from '../../global/transitions/Expand.vue'

export default {
  name: "AppFilter",
  props: ["filter", "setFilterValue", "initiallyExpanded", "forceChecked", 'executeSearch', 'showZeroResultFilters'],
  components: { TransitionExpand },
  data() {
    return {
			open: this.initiallyExpanded || (this.filter.filters && this.filter.filters.some(x => x.selected))
    };
  },
  computed: {
    model: {
      get() {
        return this.filter.selected || this.forceChecked;
      },
      set(value) {
        this.setFilterValue(this.filter, value);
        this.executeSearch();
      }
    },
		relevantFilters() {
			if (this.config.isLrlPage) return this.filter.filters.filter((x) => x.count >= 0);
			return this.filter.filters.filter((x) => x.count > 0);
		}
  },
  methods: {	
    toggle(state) {
      this[state] = !this[state];
    },
    
		filterToggleLabel() {
			let keyword = this.open ? 'Hide' : 'Show';
			return keyword + ' filter options for ' + this.group.name;
		},
  },
  watch: {
    forceChecked(newVal, oldVal) {
      if (this.filter.selected) {
        this.model = false
      }
    }
  },
  created() { },
  mounted() { },
};
